import styled from 'styled-components';

// Style
export const ContactInfoWrapper = styled.form`
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
    width: 400px;
    @media (max-width: 600px) {
        width: 100%;
    }
    .title {
        font-weight: 700;
        color: #0D2439;
        font-size: 18px;
    }
    .desc {
        font-weight: 400;
        color: black;
        font-size: 14px;
    }
    .button {
        width: 100%;
        margin-top: 10px;
    }
    .input {
        width: 100%;
    }
    .countdown {
        width: 100%;
        margin: -15px 0 !important;
    }
    .countdown-text {
        color: rgba(97, 120, 142, 1);
        font-size: 14px;
        font-weight: 500;
    }
`

export const ConfirmationWrapper = styled.form`
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
    width: 400px;
    margin: auto;
    @media (max-width: 600px) {
        width: 100%;
    }
    .title {
        font-weight: 700;
        color: #0D2439;
        font-size: 18px;
    }
    .desc {
        font-weight: 400;
        color: black;
        font-size: 14px;
    }
    .button-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 8px;
        width: 100%;
        margin-top: 10px;
    }
    .submit-button {
        width: 70%;
    }
    .input {
        width: 100%;
    }
    .phone {
        color: #0D2439;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        direction: ltr;
    }
    .row-flex {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        gap: 5px;
        background: #F5F5F5;
        padding: 0 24px;
        border-radius: 24px;
        height: 42px;
    }
`

export const ProfileWrapper = styled.form`
    margin: auto;
    background: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 450px;
    @media (max-width: 600px) {
        width: 100%;
    }
    .title {
        color: #0D2439;
        font-size: 18px;
        font-weight: 700;
        @media (max-width: 600px) {
            font-size: 17px;
        }
    }
    .inputs {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 15px;
        .input {
            width: 100%;
            height: auto;
        }
    }
    .book-button {
        height: 48px;
        width: 100%;
        border-radius: 8px;
        margin-top: 10px;
    }
`

export const SecurityWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 676px;
    padding: 35px 0;
    @media (max-width: 800px) {
        width: 500px !important;
    }
    @media (max-width: 600px) {
        width: 100% !important;
        padding: 0;
    }
    img {
        width: 308px;
        height: 198px;
        @media (max-width: 600px) {
            width: 230px;
            height: 147px;
        }
    }
    .title {
        color: rgba(0, 0, 0, 1);
        font-size: 20px;
        font-weight: 700;
        margin: 0 !important;
        width: auto;
        text-align: center;
        margin-top: 10px !important;
        line-height: 40px;
        @media (max-width: 600px) {
            font-size: 16px;
            line-height: 32px;
        }
    }
    .desc {
        color: rgba(97, 120, 142, 1);
        font-size: 14px;
        font-weight: 500;
        margin: 0 !important;
        width: 366px;
        text-align: center; 
        line-height: 28px;
        @media (max-width: 600px) {
            width: 100% !important;
        }
    }
    .button {
        background-color: rgba(69, 144, 144, 1);
        width: 228px;
        margin-top: 10px;
        @media (max-width: 600px) {
            width: 100%;
        }
    }
`